import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { AppConsts } from '../../AppConsts';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

    transform(date: DateTime): string {
        let dateFormat = AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId).name;
        const dateFormatArray = dateFormat.split("/");
        let dateArray = dateFormatArray.map(r => {
            if (r === "MM") {
                return date?.month < 10 ? '0' + date?.month : date?.month;
            }
            else if (r === "DD") {
                return date?.day < 10 ? "0" + date?.day : date?.day;
            }

            else if (r === "YYYY") {
                return date?.year
            }
        })
        return dateArray.join("/");
  }

}
